export { default as Concept } from "./Concept";
export { default as Destination } from "./Destination";
export { default as Ebrochure } from "./Ebrochure";
export { default as Faq } from "./Faq";
export { default as Gallery } from "./Gallery";
// export { default as Masterplan } from "./Masterplan";
export { default as Residences } from "./Residences";
// export { default as Siteplan } from "./Siteplan";
export { default as TheSanctuaryclub } from "./TheSanctuaryclub";



// WEBPACK FOOTER //
// ./src/pages/common/index.js